/**
 * @generated SignedSource<<211fb5e2ccd8a08cd6656facff3f10f5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type helpCenterAnnouncementFragment$data = {
  readonly header: string | null | undefined;
  readonly message: string | null | undefined;
  readonly " $fragmentType": "helpCenterAnnouncementFragment";
};
export type helpCenterAnnouncementFragment$key = {
  readonly " $data"?: helpCenterAnnouncementFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpCenterAnnouncementFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "helpCenterAnnouncementFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "header"
    },
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ],
  "type": "HelpLayoutAnnouncementElement"
};

(node as any).hash = "7a1ed4e240ff1dc0c102abd9318b56ae";

export default node;
